import common from '@/validator/CommonRules'

/**
 * イベント登録 バリデーションルール
 */
export default {
  name: 'required|max:255',
  startAt: common.requiredDateRule + '|before:endAt',
  endAt: common.requiredDateRule + '|after:startAt',
  timing: 'required',
  action: 'required',
  movieFileName: 'required_if:action,3|max:255',
  shops: 'required',
}
